module.exports = __webpack_public_path__ + "static/media/seriousEr.414723da.mp3";